import { create } from "zustand"
import type { ViewHeaderAction } from "../components/ViewHeader"

/**
 * Tiny store for page-specific overflow menu actions.
 * Pages register their actions here; TopNavMenu reads them.
 */
interface ViewMenuState {
  /** Page-specific actions (e.g. "Group by Project") */
  pageActions: ViewHeaderAction[]
  /** Total task count for Select All logic */
  totalCount: number
  setPageActions: (actions: ViewHeaderAction[]) => void
  setTotalCount: (count: number) => void
}

export const useViewMenuStore = create<ViewMenuState>((set) => ({
  pageActions: [],
  totalCount: 0,
  setPageActions: (actions) => set({ pageActions: actions }),
  setTotalCount: (count) => set({ totalCount: count }),
}))
